import {resetAuth} from '$redux/authSlice';
import store from '$redux/store';
import {v4 as uuid} from 'uuid';
import LocalStorage from './localStore';
import {unsubscribePushManager} from '../worker/registration';
import {monthNames} from '~/modules/frontdesk/Finance/Dashboard/constant';
import {getSubDomain} from '~/utils';

export const convertDateString = (dateString: string): string => {
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
};

export function formatDateString(dateString: string): string {
  const date = new Date(dateString);
  const day = date.getUTCDate().toString().padStart(2, '0');
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
}

export const logout = () => {
  unsubscribePushManager();

  LocalStorage.removeItem(LocalStorage.AUTH_USER_DATA);
  LocalStorage.removeItem(LocalStorage.APPOINTMENT_LIST_SELECTED_DATE);
  LocalStorage.removeItem(LocalStorage.PAYMENT_LIST_SELECTED_DATE);
  LocalStorage.removeItem(LocalStorage.PAYMENT_LIST_SELECTED_STATUS);
  store.dispatch(resetAuth());
};

export const getNewID = () => {
  return uuid();
};

export function formatFullName(name?: string) {
  if (name && name.length > 20) {
    return name.substring(0, 20) + '...';
  }

  return name;
}

export function toSentenceCase(str?: string): string {
  if (!str) return '';
  const trimmed = str.trim();
  if (!trimmed) return '';
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
}

export function isFutureMonth(monthStr: string) {
  const [monthName, yearStr] = monthStr.split(' ');
  const monthIndex = monthNames.indexOf(monthName);
  const year = parseInt(yearStr, 10);
  if (monthIndex === -1 || isNaN(year)) return false;
  const now = new Date();
  const selected = new Date(year, monthIndex, 1);
  return selected > new Date(now.getFullYear(), now.getMonth(), 1);
}

export const formatTime = (timeString: string) => {
  const date = new Date(timeString);
  return date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

export function getHospitalName(): string {
  const subdomain = getSubDomain();

  switch (subdomain) {
    case 'stoneygate':
      return 'Stoneygate';
    case 'summitview':
      return 'Summitview';
    default:
      return 'our hospital';
  }
}
